// Envio de eventos para o dataLayer (o GTM decide o que repassa ao GA4).
//
// Regra: NUNCA enviar dado pessoal (nome, e-mail, telefone, endereço, texto livre).

// Todas as chaves de parâmetro usadas em qualquer evento. Vão zeradas em todo push
// para o GTM não reaproveitar o valor do evento anterior (o dataLayer é "merge").
// Mantenha em sincronia com djparafestas-site/src/utils/track.js.
const CHAVES_ZERADAS = {
  page_location: undefined,
  page_title: undefined,
  tipo_pagina: undefined,
  origem_componente: undefined,
  lead_tipo: undefined,
  tipo_evento: undefined,
  cidade: undefined,
  perfil_slug: undefined,
  local_clique: undefined,
  rede: undefined,
  method: undefined,
  transaction_id: undefined,
  value: undefined,
  currency: undefined,
  origem_contato: undefined,
  // Chaves especiais do GTM usadas por trackThenNavigate: sem zerar, o callback do
  // push anterior fica no modelo de dados e dispara de novo nos eventos seguintes.
  eventCallback: undefined,
  eventTimeout: undefined,
};

export function track(event, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...CHAVES_ZERADAS, ...params });
}

// Para eventos seguidos de redirect (ex.: Stripe): dá tempo do GTM disparar as tags
// antes de sair da página. Sem GTM carregado (sem consentimento) segue após o timeout.
export function trackThenNavigate(event, params, url, timeout = 1000) {
  let done = false;
  const go = () => {
    if (done) return;
    done = true;
    window.location.href = url;
  };
  setTimeout(go, timeout);
  track(event, { ...params, eventCallback: go, eventTimeout: timeout });
}

// Evita reenviar purchase da mesma assinatura (recarregar a página, voltar no histórico).
const PURCHASE_KEY = "dpf_purchase_sent";

export function trackPurchaseOnce({ transaction_id, value, currency }) {
  if (!transaction_id) return;
  let sent = [];
  try {
    sent = JSON.parse(localStorage.getItem(PURCHASE_KEY) || "[]");
  } catch (e) {
    sent = [];
  }
  if (sent.includes(transaction_id)) return;
  track("purchase", { transaction_id, value, currency });
  try {
    localStorage.setItem(PURCHASE_KEY, JSON.stringify([...sent, transaction_id].slice(-20)));
  } catch (e) {
    // storage bloqueado — o GA4 ainda deduplica por transaction_id
  }
}
